import { render, staticRenderFns } from "./FourOFour.vue?vue&type=template&id=41580147&scoped=true&"
import script from "./FourOFour.vue?vue&type=script&lang=js&"
export * from "./FourOFour.vue?vue&type=script&lang=js&"
import style0 from "./FourOFour.vue?vue&type=style&index=0&id=41580147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41580147",
  null
  
)

export default component.exports